<template>
    <div class="container-fluid">
        <Breadcrumb title="PMTA Config Files" button-url="pmtaConfigCreate"></Breadcrumb>
        <div class="row" style="position: relative">
            <div class="col-12">
                <div class="card">
                    <div class="card-body">
                        <div class="input-group form-group">
                            <div class="form-group" v-if="this.$store.getters.isAdmin">
                                <treeselect placeholder="Search by type"
                                            v-model="typeSearch"
                                            :multiple="false"
                                            :options="typeList"
                                            :load-options="loadTypeList"
                                />
                            </div>
                            <input v-model="nameSearch" type="text" class="form-control form-control-line"
                                   placeholder="Search by name">
                            <div class="input-group-append">
                                <button v-on:click="search" class="btn btn-info" type="button">Search</button>
                            </div>
                        </div>
                        <div class="form-group mx-sm-3 mb-2">
                                <span>Total:
                                    <span class="label label-info">{{totalItems}}</span>
                                </span>
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="col-12" v-if="loading" style="min-height:100px;">
                            <Preloader v-bind:class="{preloader: loading}"></Preloader>
                        </div>
                        <div v-else>
                            <div v-if="pmtaConfigList.length > 0">
                                <div>
                                    <div class="table-responsive">
                                        <table class="table">
                                            <thead>
                                            <tr>
                                                <th @click="tableOrdering('id')">
                                                    <span role='button'>ID</span>
                                                </th>
                                                <th @click="tableOrdering('type')">
                                                    <span role='button'>Type</span>
                                                </th>
                                                <th @click="tableOrdering('name')">
                                                    <span role='button'>Name</span>
                                                </th>
                                                <th>Content</th>
                                                <th>Actions</th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            <tr v-for="(pmtaConfig, index) in pmtaConfigList" :key="index">
                                                <td class="align-middle">{{pmtaConfig.id}}</td>
                                                <td class="align-middle">{{(typeList.find( type => type['id'] === pmtaConfig.type).label)}}</td>
                                                <td class="align-middle">{{pmtaConfig.name}}</td>
                                                <td class="align-middle">
                                                    <button type="button" class="btn" @click="getConfigContent(pmtaConfig.id)">
                                                        <i class="fas fa-download"></i>
                                                    </button>
                                                </td>
                                                <td class="align-middle">
                                                    <router-link
                                                            :to="{ name: 'pmtaConfigEdit', params: { id: pmtaConfig.id }}"
                                                            class="btn btn-sm btn-info m-r-10">
                                                        <i class="fa fa-edit"></i> Edit
                                                    </router-link>
                                                    <button type="button" class="btn btn-sm btn-danger"
                                                            @click="deletePmtaConfig(pmtaConfig.id)">
                                                        <i class="fa fa-minus-circle"></i> Delete
                                                    </button>
                                                </td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <paginate v-if="pageCount > 1"
                                              v-model="page"
                                              :page-count="pageCount"
                                              :page-range="3"
                                              :margin-pages="2"
                                              :click-handler="getItems"
                                              :prev-text="'Prev'"
                                              :next-text="'Next'"
                                              :container-class="'pagination justify-content-center'"
                                              :page-class="'page-item'"
                                              :page-link-class="'page-link'"
                                              :prev-class="'page-item'"
                                              :prev-link-class="'page-link'"
                                              :next-class="'page-item'"
                                              :next-link-class="'page-link'">
                                    </paginate>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Swal from 'sweetalert2';
    import PmtaConfigService from '../services/PmtaConfigService';
    import Preloader from '../components/Preloader';
    import Breadcrumb from '../components/Breadcrumb';
    import paginateMixin from '../mixins/paginate-mixin';
    import Treeselect from '@riophae/vue-treeselect';

    export default {
        name: 'PmtaConfigs',
        components: {
            Preloader, Breadcrumb, Treeselect
        },
        mixins: [paginateMixin],
        data() {
            return {
                isAdmin: this.$store.getters.isAdmin,
                orderField: 'id',
                orderDirection: 'asc',
                pmtaConfigList: [],
                typeSearch: null,
                nameSearch: null,
                typeList: null,
                loading: false,
                totalItems: 0,
                page: 1,
                perPage: paginateMixin.defaultPerPage,
            }
        },
        mounted() {
            this.getItems(this.page = 1);
        },
        methods: {
            getItems: function (pageNum) {
                this.loading = true;
                PmtaConfigService.getPmtaConfigs(
                    pageNum,
                    this.perPage,
                    this.orderField,
                    this.orderDirection,
                    this.typeSearch,
                    this.nameSearch
                ).then(response => {
                    this.pmtaConfigList = response.data['hydra:member'];
                    this.totalItems = response.data['hydra:totalItems'];
                    this.loading = false;
                });
            },
            search: function () {
                this.getItems(this.page = 1);
            },
            tableOrdering(field) {
                if (this.orderField === field) {
                    this.orderDirection = (this.orderDirection === 'asc') ? 'desc' : 'asc';
                } else {
                    this.orderField = field;
                    this.orderDirection = 'asc';
                }
                this.getItems(this.page = 1);
            },
            deletePmtaConfig(id) {
                Swal({
                    title: 'Are you sure you want to delete?',
                    inputAttributes: {
                        autocapitalize: 'off'
                    },
                    showCancelButton: true,
                    confirmButtonText: 'Confirm',
                    showLoaderOnConfirm: true,
                    preConfirm: () => {
                        return PmtaConfigService.deletePmtaConfig(id).then((response) => {
                            if (response.status === 204) {
                                let pmtaConfigIndex = this.pmtaConfigList.findIndex(obj => obj.id === id);
                                this.pmtaConfigList.splice(pmtaConfigIndex, 1);
                                this.totalItems--;
                            } else {
                                Swal.showValidationMessage(
                                    `Delete failed: ${response.data.error}`
                                );
                                return false;
                            }
                        }).catch(error => {
                            Swal.showValidationMessage(
                                'Error: ' + error.response.data.error[0]
                            )
                        });
                    },
                    allowOutsideClick: () => !Swal.isLoading()
                }).then((result) => {
                    if (result.value) {
                        Swal(
                            'Deleted successfully!',
                            `Pmta Config File has been deleted.`,
                            'success'
                        )
                    }
                })
            },
            loadTypeList({callback}) {
                PmtaConfigService.getTypeList().then(response => {
                    this.typeList = response.data.types.map((type, index) => {
                        return {id: index, label: type}
                    });
                    callback();
                });
            },
            getConfigContent(id) {
                PmtaConfigService.getPmtaConfigContent(id).then((response) => {
                    if (response.status === 200) {
                        let previewWindow = window.open();
                        previewWindow.document.open();
                        previewWindow.document.write(response.data.content);
                        previewWindow.document.close();
                    }
                    if (response.status >= 400) {
                        Swal(
                            'Oops!',
                            'Sorry, something went wrong.',
                            'error'
                        );
                    }
                })
            },
        },
        computed: {
            pageCount: function () {
                return Math.ceil(this.totalItems / this.perPage);
            }
        }
    }
</script>

<style scoped>

</style>